import {Observable, BehaviorSubject} from 'rxjs';

export class DipRegistrationStore<T> {
  state$: Observable<T>;
  private internalState$: BehaviorSubject<T>;

  protected constructor(initialState: T) {
    this.internalState$ = new BehaviorSubject(initialState);
    this.state$ = this.internalState$.asObservable();
  }

  get state(): T {
    return JSON.parse(JSON.stringify(this.internalState$.getValue()));
  }

  setState(nextState: T): void {
    this.internalState$.next(nextState);
  }
}
